import React from "react";
import PropTypes from "prop-types";

import { KeepEditsText, KeepEditsButton, LoseEditsButton } from "./styles";
import Modal from "core/Modal";

import { PRO_ANNUAL_DOWNLOAD } from "icons/helpers";
import { ICON_CHECKOUT } from "data/links";

const KeepEditsWarning = ({
    onClose,
    onLoseEditsClick,
    iconId,
    show = false
}) => {
    const proCheckout = ICON_CHECKOUT.replace(
        ":checkoutType",
        PRO_ANNUAL_DOWNLOAD
    ).replace(":iconId", iconId);

    return (
        <Modal
            open={show}
            handleClose={onClose}
            type="warning"
            heading="Select NounPro To Keep Your Edits"
        >
            <KeepEditsText>
                A NounPro subscription unlocks editing, apps &amp; plugins, plus
                unlimited royalty-free downloads.
            </KeepEditsText>
            <KeepEditsButton href={proCheckout}>
                Keep Edits With Pro
            </KeepEditsButton>
            <LoseEditsButton {...onLoseEditsClick}>
                Lose my edits
            </LoseEditsButton>
        </Modal>
    );
};

KeepEditsWarning.propTypes = {
    onClose: PropTypes.func.isRequired, // if "x" (close modal) is clicked
    onLoseEditsClick: PropTypes.object.isRequired, // button props: { href } or { onClick }
    iconId: PropTypes.string.isRequired,
    show: PropTypes.bool
};

export default KeepEditsWarning;
